import { Box } from '@chakra-ui/react';
import React from 'react';
import { IItem, TPartialItemWithItemID } from '../../../../../../game-server/src/modules/items/items.interface';
import { TCosmeticSlots } from '../../../../../../game-server/src/modules/player/PlayerSettings';
import { TEquipmentSlots } from '../../../../../../game-server/src/modules/player/PlayerTypes';
import { itemList } from '../../../../utils/itemList';
import { Item } from '../../Inventory/Item';
import '../../Inventory/Item.css';

export default function CombatGearItemDisplay(props: {
	slot: TEquipmentSlots;
	item?: TPartialItemWithItemID<IItem>;
	borderColor?: string;
	onClick?: () => void;
	grayscale?: boolean;
}) {
	return (
		<Box id={`gear-${props.slot}`} className='combat-gear-item' onClick={props.onClick}>
			{props.item && (
				<Item
					item={props.item}
					width='48px'
					height='48px'
					margin='1px'
					variant={props.grayscale ? 'grayscale' : undefined}
					{...(!props.grayscale && props.borderColor
						? {
								borderWidth: '2px',
								borderStyle: 'solid',
								borderColor: props.borderColor,
						  }
						: undefined)}
				/>
			)}
		</Box>
	);
}

export function showGrayscaleShield(slot: TCosmeticSlots, weapon: TPartialItemWithItemID<IItem> | undefined) {
	if (slot !== 'shield') return false;
	const weaponData = weapon && itemList[weapon.itemID];
	return !!weaponData?.equipmentStats && !weaponData.equipmentStats.oneHanded;
}
